// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1selp","head":"Table_head__8QlUR","col":"Table_col___3APG"};